
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","width":"31","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"fill":"#FFA200","width":"30.8","height":"22","rx":"3.358"}}),_c('path',{attrs:{"d":"M26.297 10.84h-.233V9.603h.233c.512 0 .745.23.745.597 0 .413-.233.642-.745.642zm1.583-.687c0-.78-.512-1.193-1.443-1.193h-1.165v4.083h.792V11.39h.093l1.071 1.652h.978l-1.257-1.698c.559-.091.978-.596.931-1.192zm-5.355 2.89h2.235v-.688h-1.444v-1.101h1.397v-.688h-1.397v-.918h1.444V8.96h-2.235v4.083zm-2.329-1.33L19.125 8.96h-.838l1.723 4.174h.419l1.723-4.174h-.838l-1.118 2.752zm-9.454-.689c0 1.147.931 2.11 2.096 2.11a2.57 2.57 0 001.024-.229v-.917c-.233.275-.559.458-.931.458-.745 0-1.35-.55-1.35-1.284v-.092c-.047-.734.558-1.376 1.303-1.422.373 0 .745.184.978.459V9.19c-.28-.184-.652-.23-.978-.23-1.21-.091-2.142.872-2.142 2.064zm-1.444-.504c-.466-.184-.605-.275-.605-.505.046-.275.28-.504.559-.458.233 0 .465.137.652.32l.419-.55c-.326-.275-.745-.458-1.165-.458a1.188 1.188 0 00-1.257 1.1v.046c0 .55.233.872.978 1.101.186.046.373.138.559.23a.48.48 0 01.233.412c0 .321-.28.597-.56.597h-.046a.92.92 0 01-.838-.55l-.512.504c.28.504.838.78 1.397.78a1.306 1.306 0 001.397-1.239v-.138c-.046-.55-.28-.825-1.21-1.192zm-2.7 2.523h.79V8.96h-.79v4.083zm-1.584-1.01a1.49 1.49 0 01-1.072.322H3.71V9.648h.232a1.49 1.49 0 011.072.321c.28.276.419.643.419 1.01 0 .412-.14.78-.42 1.054zM4.082 8.96H2.918v4.083h1.164c.512.045 1.025-.138 1.444-.46.466-.412.745-.962.745-1.559.047-1.1-.838-2.018-1.956-2.064h-.233zm12.155-.094c-1.164 0-2.142.917-2.142 2.11 0 1.146.932 2.11 2.142 2.155 1.211.046 2.143-.917 2.19-2.11-.047-1.192-.979-2.155-2.19-2.155z","fill":"#FFF"}})])])
          )
        }
      }
    